import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';

interface VendorSearchDialogProps {
  fullWidth: boolean;
  openSelectModal: boolean;
  handleCloseSelectModal: () => void;
  vendorData: Array<any>;
  setVendorData: any;
  vendorDataSearch: Array<any>;
  setVendorName: any;
}

export const VendorSearchDialog: React.FC<VendorSearchDialogProps> = ({
  fullWidth,
  openSelectModal,
  handleCloseSelectModal,
  vendorData,
  setVendorData,
  vendorDataSearch,
  setVendorName
}) => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [vendorType, setVendorType] = useState('');

  useEffect(() => {
    if (openSelectModal) {
      filterVendorData(searchKeyword, vendorType);
    }
  }, [openSelectModal]);

  const handleSearchChange = (e: any) => {
    setSearchKeyword(e.target.value);
    filterVendorData(e.target.value, vendorType);
  };

  const handleVendorTypeChange = (e: any) => {
    setVendorType(e.target.value);
    filterVendorData(searchKeyword, e.target.value);
  };

  const filterVendorData = (keyword: any, type: any) => {
    let filterArray = vendorDataSearch;
    let searchResult = filterArray.filter(data => {
      const matchesKeyword =
        data.name.toUpperCase().includes(keyword.toUpperCase()) ||
        data.furigana.toUpperCase().includes(keyword.toUpperCase());
      const matchesType =
        type === '' ||
        (type === 'supplier' && data.large_type === '仕入先') ||
        (type === 'contractor' && data.large_type === '外注');
      return matchesKeyword && matchesType;
    });
    setVendorData(searchResult);
  };

  return (
    <Dialog
      fullWidth={fullWidth}
      open={openSelectModal}
      onClose={handleCloseSelectModal}
    >
      <DialogTitle id='set_construct_title'>
        <div>業者検索</div>
        <div style={{ marginTop: 10 }}>
          <input
            placeholder='検索'
            value={searchKeyword}
            style={{
              backgroundColor: '#F3F3F3',
              borderRadius: 5,
              width: '100%',
              padding: 5
            }}
            onChange={handleSearchChange}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 10
          }}
        >
          <label style={{ margin: '0 30px' }}>
            <input
              type='radio'
              name='vendorType'
              value=''
              checked={vendorType === ''}
              onChange={handleVendorTypeChange}
              style={{ transform: 'scale(1.5)', marginRight: 5 }}
            />
            全て
          </label>
          <label style={{ marginRight: 30 }}>
            <input
              type='radio'
              name='vendorType'
              value='supplier'
              checked={vendorType === 'supplier'}
              onChange={handleVendorTypeChange}
              style={{ transform: 'scale(1.5)', marginRight: 5 }}
            />
            仕入業者のみ
          </label>
          <label style={{ marginRight: 30 }}>
            <input
              type='radio'
              name='vendorType'
              value='contractor'
              checked={vendorType === 'contractor'}
              onChange={handleVendorTypeChange}
              style={{ transform: 'scale(1.5)', marginRight: 5 }}
            />
            外注業者のみ
          </label>
        </div>
      </DialogTitle>
      <DialogContent>
        {vendorData.map(i => (
          <div
            className='search-item'
            onClick={() => {
              setVendorName(i.id);
              handleCloseSelectModal();
            }}
          >
            {i.name}
          </div>
        ))}
        {vendorData.length === 0 && (
          <div style={{ color: '#FF6263', fontSize: 16 }}>
            データがありません
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VendorSearchDialog;
